import { render, staticRenderFns } from "./relationDesignation.vue?vue&type=template&id=1d4c5424&scoped=true"
import script from "./relationDesignation.vue?vue&type=script&lang=js"
export * from "./relationDesignation.vue?vue&type=script&lang=js"
import style0 from "./relationDesignation.vue?vue&type=style&index=0&id=1d4c5424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c5424",
  null
  
)

export default component.exports